export const getProbableFathers = (animals, events, mother, birthDate) => {
    const malesOnLocation = [];
    // Find the probable fathers
    // 1 - get date 160 days from birthDate
    // 2 - get date 140 days from birthDate
    // 3 - get the mother location(s) 140 to 160 days ago
    // 4 - find and filter males that was on this location 140 to 160 days ago
    // 5 - filter males that was here 140 to 160 days ago
    const daysAgo140 = new Date(birthDate);
    daysAgo140.setDate(daysAgo140.getDate() - 140);
    const daysAgo160 = new Date(birthDate);
    daysAgo160.setDate(daysAgo160.getDate() - 160);
    // get mother location(s) 140 to 160 days from birthDate
    const motherMovements = events.filter(evt => parseInt(evt.type) === 1 && mother.id == parseInt(evt.animalId));
    let prev = false;
    const motherLocations = [];
    //// for each movement of the mother get locationId, start date, end date of the mother presence
    motherMovements.forEach(evt => {
        let d1 = new Date(evt.dateApi);
        let d2 = prev ? new Date(prev.dateApi) : new Date(birthDate);
        ////  get locations in 140-160 days interval
        if (daysAgo140 >= d1 && daysAgo160 <= d2) {
            motherLocations.push(evt.locationId);
        }
        prev = evt;
    })
    // find males that was present on this locations 140 to 160 days from birthDate
    const males = animals.filter(a => parseInt(a.sex) === 1 || parseInt(a.sex) === 3);
    const malesMovements = events.filter(evt => parseInt(evt.type) === 1
        && males.find(m => parseInt(m.id) == parseInt(evt.animalId)));
    prev = [];
    malesMovements.forEach(evt => {
        let d2;
        let d1 = new Date(evt.dateApi);
        if (!prev[evt.animalId]) {
            //// if it's the first time we found this animal
            d2 = new Date(birthDate);
            prev[evt.animalId] = [];
        } else {
            d2 = new Date(prev[evt.animalId][prev[evt.animalId].length - 1].dateApi);
        }
        //// filter animals that was present 140 to 160 days from birth date in mother location(s)
        if (motherLocations.includes(evt.locationId) && daysAgo140 >= d1 && daysAgo160 <= d2) {
            malesOnLocation.push({
                animalId: evt.animalId,
                animalName: evt.animalName,
                toString: () => evt.animalName
            });
        }
        prev[evt.animalId].push(evt);
    })
    return malesOnLocation
}